import React, { useState } from 'react';
import OnboardingStep from './OnboardingStep';
import StepAspiration from './StepAspiration';
import StepExperience from './StepExperience';
import StepTimeCommitment from './StepTimeCommitment';
import { useNavigate } from 'react-router-dom';

const Onboarding = () => {
  const navigate = useNavigate();
  const [step, setStep] = useState(1);
  const [aspiration, setAspiration] = useState('');
  const [experience, setExperience] = useState('');
  const [timeCommitment, setTimeCommitment] = useState(5);

  const nextStep = () => setStep(step + 1);
  const prevStep = () => setStep(step - 1);

  const handleFinish = () => {
    // Redirect to results page, passing preferences via state
    navigate('/results', {
      state: { preferences: { aspiration, experienceLevel: experience, timeCommitment } }
    });
  };

  return (
    <div className="onboarding-flow">
      {step === 1 && (
        <OnboardingStep
          stepNumber={1}
          title="Select the industry where you want to build your career."
          onNext={nextStep}
          onBack={prevStep}
          isFirstStep={true}
        >
          <StepAspiration value={aspiration} onChange={setAspiration} />
        </OnboardingStep>
      )}

      {step === 2 && (
        <OnboardingStep
          stepNumber={2}
          title="What is your current level of experience?"
          onNext={nextStep}
          onBack={prevStep}
        >
          <StepExperience value={experience} onChange={setExperience} />
        </OnboardingStep>
      )}

      {step === 3 && (
        <OnboardingStep
          stepNumber={3}
          title="How many hours per week can you realistically commit to learning?"
          onNext={handleFinish}
          onBack={prevStep}
          isLastStep={true}
        >
          <StepTimeCommitment value={timeCommitment} onChange={setTimeCommitment} />
        </OnboardingStep>
      )}
    </div>
  );
};

export default Onboarding;
